import { FunctionComponent } from 'react';
import { ExternalLinkIcon } from '@rsos/base-assets/icons';
import { Text } from '@rsos/base-components';
import { Box, Button } from '@rsos/components/capstone/base';
import { trackTrainingClicked } from './TrainingBtnTrackings';

interface TrainingBtnProps {
  handleSAMLRequest: (service: string) => void;
}

export const TrainingBtn: FunctionComponent<TrainingBtnProps> = ({
  handleSAMLRequest,
}) => {
  const handleClick = () => {
    trackTrainingClicked();
    handleSAMLRequest('training');
  };
  return (
    <Box horizontal onClick={handleClick}>
      <Button btnType="tertiary" size="small" type="submit">
        <Text mr="4px">Open Training</Text>
        <ExternalLinkIcon width={12} height={12} />
      </Button>
    </Box>
  );
};

export default TrainingBtn;
